var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { registry, runFactory } from './registryCore';
import { getState, num, setState } from './helpers';
import { resolveBounds } from './layout';
function isAutoGroup(node) {
    var _a;
    return 'children' in node && typeof ((_a = node.metadata) === null || _a === void 0 ? void 0 : _a.autoType) === 'string';
}
function syncAutoAppViewport(node, width, height) {
    var app = node.getApp();
    if (!app || app.stage.children.length !== 1 || app.stage.children[0] !== node)
        return;
    var size = app.getSize();
    if (size.width !== width || size.height !== height) {
        app.resize(width, height);
    }
}
/** Attach rebuild hook so widget visuals can be regenerated from autoState. */
export function installAutoWidgetRebuild(group, app, autoType) {
    var _a;
    var type = autoType !== null && autoType !== void 0 ? autoType : (_a = group.metadata) === null || _a === void 0 ? void 0 : _a.autoType;
    if (!type)
        return;
    var rebuild = function () {
        var e_1, _a, e_2, _b;
        var _c;
        var factory = registry[type];
        if (!factory)
            return;
        var props = __assign(__assign({}, getState(group)), { x: group.x, y: group.y });
        var fresh = runFactory(factory, props, app);
        if (!fresh || !isAutoGroup(fresh))
            return;
        try {
            for (var _d = __values(__spreadArray([], __read(group.children), false)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var child = _e.value;
                group.remove(child);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var _f = __values(__spreadArray([], __read(fresh.children), false)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var child = _g.value;
                fresh.remove(child);
                group.add(child);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_2) throw e_2.error; }
        }
        group.metadata._parts = fresh.metadata._parts;
        group.metadata.refresh = fresh.metadata.refresh;
        group.metadata.boolRefresh = fresh.metadata.boolRefresh;
        group.metadata.textRefresh = fresh.metadata.textRefresh;
        group.metadata.linesRefresh = fresh.metadata.linesRefresh;
        group.metadata._digitalParts = fresh.metadata._digitalParts;
        group.metadata.autoState = __assign(__assign(__assign(__assign({}, fresh.metadata.autoState), (props.fontSize != null ? { fontSize: props.fontSize } : {})), (props.demoId != null ? { demoId: props.demoId } : {})), (props.theme != null ? { theme: props.theme } : {}));
        var w = num(props, 'width', 0);
        var h = num(props, 'height', 0);
        if (w > 0) {
            group.metadata.chartWidth = w;
            group.metadata.autoWidth = w;
        }
        if (h > 0) {
            group.metadata.chartHeight = h;
            group.metadata.autoHeight = h;
        }
        group.metadata.autoRebuild = rebuild;
        app.requestRender();
        var renderer = (_c = app.getRenderer) === null || _c === void 0 ? void 0 : _c.call(app);
        if (renderer && typeof renderer.forceFullRedraw === 'function') {
            renderer.forceFullRedraw();
        }
    };
    group.metadata.autoRebuild = rebuild;
}
/** Patch widget state and rebuild layers (resize, theme, value updates). */
export function updateAutoWidgetProps(group, patch) {
    if (!isAutoGroup(group))
        return;
    var prev = getState(group);
    var sizeKeys = ['width', 'height', 'size'];
    var onlySize = Object.keys(patch).every(function (k) { return sizeKeys.includes(k); });
    if (onlySize) {
        var same = (!('width' in patch) || num(patch, 'width', -1) === num(prev, 'width', -2)) &&
            (!('height' in patch) || num(patch, 'height', -1) === num(prev, 'height', -2)) &&
            (!('size' in patch) || num(patch, 'size', -1) === num(prev, 'size', -2));
        if (same)
            return;
    }
    setState(group, patch);
    var state = getState(group);
    if (('width' in patch || 'height' in patch) && (num(state, 'size', 0) > 0 || 'size' in state)) {
        var bounds = resolveBounds(state, num(state, 'width', 160), num(state, 'height', 120));
        if (bounds.dialSize !== num(state, 'size', 0)) {
            setState(group, { size: bounds.dialSize });
        }
    }
    var w = num(patch, 'width', num(state, 'width', 0));
    var h = num(patch, 'height', num(state, 'height', 0));
    if (w > 0) {
        group.metadata.chartWidth = w;
        group.metadata.autoWidth = w;
    }
    if (h > 0) {
        group.metadata.chartHeight = h;
        group.metadata.autoHeight = h;
    }
    var rebuild = group.metadata.autoRebuild;
    rebuild === null || rebuild === void 0 ? void 0 : rebuild();
    if (w > 0 && h > 0) {
        syncAutoAppViewport(group, w, h);
    }
}
/** Rebuild automotive widgets after app typography / theme sync. */
export function refreshAutomotive(root) {
    var walk = function (n) {
        var e_3, _a;
        var _b;
        if (typeof ((_b = n.metadata) === null || _b === void 0 ? void 0 : _b.autoType) === 'string') {
            var rebuild = n.metadata.autoRebuild;
            rebuild === null || rebuild === void 0 ? void 0 : rebuild();
        }
        if ('children' in n) {
            try {
                for (var _c = __values(n.children), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var child = _d.value;
                    walk(child);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    walk(root);
}
